import React, {useState, useEffect} from "react";
import { connect } from 'react-redux';
import classes from './heroSection.module.css';
import Button from '../../containers/button/button';

const HeroSection = (props) => {    
    const [width, setWidth] = useState(0);
    
    // Use Redux for language management
    const isEnglish = props.selectedLanguage === 1;
    
    const handleResize = () => setWidth(window.innerWidth);
    useEffect(() => {
        setWidth(window.innerWidth)
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);
    const createTournamentHandler = () => {
        if (props.createTournamentRef?.current) {
            const formElement = props.createTournamentRef.current;
            // Scroll to the form 
            const formPosition = formElement.getBoundingClientRect().top + window.pageYOffset;
            const offset = width > 599 ? 89 : 46; // Header height
            // Scroll to the calculated position with smooth behavior, including the offset
            window.scrollTo({
                top: formPosition - offset,
                behavior: 'smooth',
            });
        }
    };
    
    // Create dynamic class for the title based on language
    const titleClass = [
        classes.Title,
        !isEnglish ? classes.RTLTitle : ''
    ].filter(Boolean).join(' ');
    
    // Create dynamic classes for the description paragraphs
    const descriptionClass = [
        classes.Description,
        !isEnglish ? classes.RTLDescription : ''
    ].filter(Boolean).join(' ');
    
    const otherDescriptionClass = [
        classes.OtherDescription,
        !isEnglish ? classes.RTLOtherDescription : ''
    ].filter(Boolean).join(' ');
    
    return (
        <div className={classes.Container}>
            <div className={classes.Background}>
                <h1 className={titleClass}>
                    {isEnglish ? "TOURNAMENTS" : "البطولات"}
                </h1>
            </div>
            <p className={descriptionClass}>
                {isEnglish 
                    ? "have a tournament on your mind, tell us about it and we will create & organize it for you" 
                    : "هل لديك بطولة في ذهنك؟ أخبرنا عنها وسنقوم بإنشائها وتنظيمها لك"}
            </p>
            <p className={otherDescriptionClass} style={{ border: 'none' }}>
                {isEnglish 
                    ? "Fill out the following form and our team will contact you shortly" 
                    : "املأ النموذج التالي وسيتواصل معك فريقنا قريباً"}
            </p>
            <Button 
                content={isEnglish ? "CREATE A TOURNAMENT" : "إنشاء بطولة"} 
                onClick={createTournamentHandler} 
            />
        </div>
    )
}

const mapStateToProps = state => ({
    selectedLanguage: state.home.selected_language
});

export default connect(mapStateToProps)(HeroSection);